import React, { useEffect, useState } from "react";
import api from "../../../api/api";
import toast from "react-hot-toast";

const AdminMedia = () => {
  const [media, setMedia] = useState([]);
  const [uploading, setUploading] = useState(false);

  const load = async () => {
    const res = await api.get("/media");
    setMedia(res.data);
  };

  const upload = async (file) => {
    setUploading(true);

    try {
      const body = new FormData();
      body.append("file", file);

      await api.post("/media/upload", body);
      toast.success("Media uploaded");
      load();
    } catch (err) {
      toast.error(err.cleanMessage);
    } finally {
      setUploading(false);
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Delete media?")) return;

    try {
      await api.delete(`/media/${id}`);
      toast.success("Media deleted");
      load();
    } catch (err) {
      toast.error(err.cleanMessage);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <section>
      <h1 className="text-3xl font-black text-[#0b6b1d] mb-6">Media</h1>

      <div className="bg-white border rounded-3xl p-6 mb-6">
        <input type="file" accept="image/*" onChange={(e) => upload(e.target.files[0])} />
        {uploading && <p className="mt-2 text-sm">Uploading...</p>}
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {media.map((item) => (
          <div key={item.id} className="bg-white border rounded-3xl overflow-hidden">
            <img src={item.url} alt="" className="w-full h-44 object-cover" />

            <div className="p-4">
              <p className="text-sm truncate">{item.original_name}</p>

              <button
                onClick={() => remove(item.id)}
                className="mt-3 text-red-600 text-sm font-bold"
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AdminMedia;